if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    initAllBenefitsSectionVideos();
  });
} else {
  initAllBenefitsSectionVideos();
}

document.addEventListener('shopify:section:load', function (event) {
  initAllBenefitsSectionVideos(event.target);
});

function initAllBenefitsSectionVideos(scope) {
  (scope || document).querySelectorAll('.benefits-section').forEach(initBenefitsSectionVideos);
}

function initBenefitsSectionVideos(sectionRoot) {
  if (!sectionRoot || sectionRoot.dataset.benefitsVideoReady === 'true') return;
  if (window.__ultraShouldSuppressVideo === true) return;

  var videos = Array.prototype.slice.call(sectionRoot.querySelectorAll('video'));
  if (!videos.length) return;

  sectionRoot.dataset.benefitsVideoReady = 'true';

  var intersectionByVideo = new Map();

  function isLaidOut(el) {
    return el.getClientRects().length > 0;
  }

  function isInViewport(el) {
    var rects = el.getClientRects();
    if (!rects.length) return false;
    var rect = rects[0];
    var vh = window.innerHeight || document.documentElement.clientHeight;
    return rect.bottom > 0 && rect.top < vh;
  }

  function ensureVideoSources(video) {
    if (video.dataset.sourcesReady === 'true') return;

    var needsLoad = false;
    video.querySelectorAll('source').forEach(function (source) {
      var dataSrc = source.getAttribute('data-src');
      if (dataSrc && !source.getAttribute('src')) {
        source.setAttribute('src', dataSrc);
        needsLoad = true;
      }
    });

    if (needsLoad) {
      try {
        video.load();
      } catch (error) {}
    }

    video.dataset.sourcesReady = 'true';
  }

  function playVideo(video) {
    if (window.__ultraShouldSuppressVideo === true) return;
    ensureVideoSources(video);
    video.muted = true;
    video.playsInline = true;
    video.loop = true;
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function syncVideos() {
    videos.forEach(function (video) {
      var shouldPlay =
        isLaidOut(video) && (intersectionByVideo.get(video) === true || isInViewport(video));
      if (shouldPlay) {
        playVideo(video);
      } else {
        video.pause();
      }
    });
  }

  videos.forEach(function (video) {
    video.muted = true;
    video.playsInline = true;
    video.loop = true;
    video.preload = 'metadata';
    video.removeAttribute('autoplay');
    intersectionByVideo.set(video, false);
  });

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          intersectionByVideo.set(
            entry.target,
            entry.isIntersecting && entry.intersectionRatio >= 0.2
          );
        });
        syncVideos();
      },
      { rootMargin: '100px 0px', threshold: [0, 0.2, 0.5, 1] }
    );

    videos.forEach(function (video) {
      observer.observe(video);
    });
  } else {
    videos.forEach(function (video) {
      intersectionByVideo.set(video, true);
    });
    syncVideos();
  }

  var mediaQuery = window.matchMedia('(min-width: 990px)');
  if (mediaQuery.addEventListener) {
    mediaQuery.addEventListener('change', syncVideos);
  } else if (mediaQuery.addListener) {
    mediaQuery.addListener(syncVideos);
  }

  window.addEventListener('resize', syncVideos);

  function onPageLoad() {
    videos.forEach(function (video) {
      if (window.__ultraShouldSuppressVideo === true) return;
      video.preload = 'auto';
      ensureVideoSources(video);
    });
    syncVideos();
  }

  if (document.readyState === 'complete') {
    onPageLoad();
  } else {
    window.addEventListener('load', onPageLoad);
  }
}
